import { Request } from '@group-devs/yfp7-global-modules'
import { Footer } from '@group-devs/yfp7-global-modules/components/Block'
import { useRouter } from 'next/router'
import {useEffect} from 'react'
import { WellnessTopNav, WellnessFooterNav } from '@components/Block'
import Head from 'next/head'
import ReactGA from 'react-ga';
import { stripTags } from '@group-devs/yfp7-global-modules/utils/general'

const request = new Request(process.env.apiDomain)

function Layout(props) {
    
    const router = useRouter()
    const auth = props.global.auth
    const site = props.global.site
    const { data: hub } = request.website.swrSite(site.accountId, "HUB")
    const { data: nav } = request.website.swrNavigation(hub ? hub.url : hub)
    const { data: tracker } = request.insights.swrTracking(site.id)

    useEffect(()=>{
        if (tracker)
        {
            try {
                if (tracker.ga_id)
                {
                    ReactGA.initialize(tracker.ga_id);
                    ReactGA.pageview(window.location.pathname + window.location.search);
                }
                if (tracker.matomo_id && tracker.matomoServer)
                {
                    var _paq = window._paq = window._paq || [];
                    _paq.push(['trackPageView']);
                    _paq.push(['enableLinkTracking']);
                    (function() {
                        var u= (tracker.matomoServer.includes("http") ? "" : "//") + tracker.matomoServer.replace(/\/$/, "");
                        _paq.push(['setTrackerUrl', u+'/matomo.php']);
                        _paq.push(['setSiteId', tracker.matomo_id]);
                        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                        g.type='text/javascript'; g.async=true; g.src=u+'/matomo.js'; s.parentNode.insertBefore(g,s);
                    })();
                }
            } catch (error) {
                console.error("Tracker Error:", error);
            }
        }
    }, [tracker])
  
  
    const pageTitle = props && props.article && props.article.title ? props.article.title : site.name + " - Wellness Center";
    const title = props && props.article && props.article.title ? props.article.title : '';
    const theExcerpt = props && props.article && props.article.theExcerpt ? props.article.theExcerpt : '';
    const image = props && props.article && props.article.featureImg ? props.article.featureImg : '';

    return (
        <div className="page-layout wellnessCenter">
            <Head>
                <title>{pageTitle}</title>
                <meta property="og:url" content={ "https://" + site.url + router.asPath } />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                
                { theExcerpt ? 
                <>
                    <meta property="og:description" content={stripTags(theExcerpt)} />
                </>
                : null }
                { image ? <meta property="og:image" content={image} /> : null }
                { theExcerpt ? 
                <>
                    <meta name="description" content={stripTags(theExcerpt)} />
                </>
                : null }
                <meta name="author" content={site.name} />
                <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet"/>
            </Head>
            <WellnessTopNav site={site} auth={auth} searchItems={props.searchItems}/>
            {props.children}
            { nav ? <Footer host={props.global.host} site={site} navigation={nav.footer_navigation} origin="wellness"/> : null }
            <WellnessFooterNav auth={props.global.auth} site={site} />

            <style jsx global>{`

            body{
                font-family: 'Montserrat', sans-serif;
                color:#000;
            }

            .dropdown-item{
                color:#232323;
                padding: .25rem 1rem;
            }

            .myStrip__media{
                border: 2px solid;
            }

            .myStrip__media svg {
                position: relative;
                top: -2px;
            }

            .footer__menuLinks{
                border-color: #ecca28!important;
            }

            `}</style>
        
        </div>
    )
    
}

export default Layout